<template>
  <div class="gov-measure-tool-field-wrap">
    <el-popover placement="top-start" title="工程量" width="200" trigger="hover" :content="textarea">
      <div class="input-wrap" slot="reference">
        <el-input
          :size="size"
          readonly
          :disabled="disabled"
          v-model="input"
          @blur="handleBlur"
          placeholder="请输入工程量"
        >
          <i class="el-icon-edit el-input__icon" slot="suffix" @click="handleIconClick"></i>
          <template slot="append" v-if="unitId">{{unitName}}</template>
        </el-input>
      </div>
    </el-popover>
    <el-dialog
      :title="popupsTitle"
      :visible.sync="showEdit"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
    >
      <span>
        <el-input type="textarea" :rows="2" placeholder="请输入工程量" v-model="textarea"></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button :size="size" @click="handleCancel">取 消</el-button>
        <el-button :size="size" type="primary" @click="handleEvaluate">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-button type="text">工程量</el-button> -->
  </div>
</template>

<script>
// import { excuter } from '@/untils/math';
export default {
  name: 'GovMeasureTool',
  componentName: 'GovMeasureTool',
  props: {
    unitId: [String],
    size: {
      type: String,
      default: 'small'
    },
    dot: {
      type: Number,
      default: 0
    },
    unitName: [String],
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: '字段'
    },
    value: [String, Number]
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        try {
          if (typeof val === 'string') {
            val = val.replace(/\=/g, '');
          }
          if (val === '' || val === null || val === undefined) {
            this.input = '';
          } else {
            const resutl = excuter(val);
            let num = Number(resutl);
            if (Number.isNaN(num)) {
              num = 0;
            }
            this.input = num.toFixed(this.dot);
          }
          this.textarea = val;
        } catch (e) {
          this.input = '';
          this.textarea = '';
        }
      }
    }
  },
  computed: {
    popupsTitle() {
      return this.label + '-工程量';
    }
  },
  data() {
    return {
      input: '',
      textarea: '',
      oldExp: '',
      showEdit: false
    };
  },
  methods: {
    handleBlur() {
      this.$emit('input', this.textarea);
    },
    // 打开编辑
    handleIconClick() {
      if (this.disabled) {
        return false;
      }
      this.oldExp = this.textarea;
      this.showEdit = true;
    },
    // 取消编辑
    handleCancel() {
      this.textarea = this.oldExp;
      this.showEdit = false;
    },
    handleEvaluate() {
      let val = '';
      try {
        val = excuter(this.textarea);
      } catch (e) {
        this.$message({
          message: '输入的公式有误，请重新输入',
          type: 'warning'
        });
        return false;
      }
      let num = Number(val);
      if (Number.isNaN(num)) {
        num = 0;
      }
      this.input = num.toFixed(this.dot);
      // this.$emit('input', this.input);
      this.$emit('input', this.textarea);
      this.showEdit = false;
    }
  }
};
</script>

<style>
.gov-measure-tool-field-wrap {
  position: relative;
  display: inline-block;
  width: 100%;
}
.el-icon-edit {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/measure-tool.vue